import { DateTime } from 'luxon';

export class MyScore {
   public createdAt: Date;
   public opponentFullName: string;
   public opponentId: string;
   public points: number;
   public round: number;
   public score: string;

   public recordedBy: string;
   public lastName: string; // used for sorting
   public matchId: number;
   public ladderId: string;

   public getDate = () => {
      var j = this.createdAt;
      return DateTime.fromISO(this.createdAt).toLocaleString(DateTime.DATE_MED);
   }
   public isLessThanWeekOld() {
      const weekAgo = DateTime.local().plus({ days: -7 });
      return DateTime.fromISO(this.createdAt) > weekAgo;
   }
   constructor(data?: Partial<MyScore>) {
      Object.assign(this, data);
   }
}

export class MyScores {
   public fullName: string = ""; // used to show opponents name
   public results: Scores[] = [];

   constructor(data?: Partial<MyScores>) {
      Object.assign(this, data, { results: [] });
      if (data && data.results) {
         data.results.forEach(elm => {
            this.results.push(new Scores(elm));
         });
      }
   }
}

export class Scores {
   public levelId: number;
   public levelNameLong: string;
   public levelNameShort: string;
   public ladderType: string;
   public ladderEnded: boolean;
   public ladderEndDate: string;
   public totalPoints: number;
   public scores: MyScore[] = [];
   constructor(data?: Partial<Scores>) {
      Object.assign(this, data, { scores: [] });

      if (data && data.scores) {
         data.scores.forEach(elm => {
            this.scores.push(new MyScore(elm));
         });
      }
   }
}
